import {
  SET_BENEFICIARIES,
  SET_BENEFICIARIES_TO_SELECT,
  SET_REPORT_DATA,
  CLEAR_BENEFICIARY,
  SET_BENEFICIARIES_CHECKED,
  SET_COUNT_BENEFICIARIES_WITH_COLLECTION,
  SET_COUNT_BENEFICIARIES_BY_COMPANY_OR_PROGRAMME,
  SET_BENEFICIARIES_TO_MESSAGE,
  SET_BENEFICIARIES_TO_ACCESS_CONTROL,
  UPDATE_BENEFICIARY_PHOTO_IN_STORE
} from '@actions/beneficiary'

const defaultState = {
  reportData: null,
  beneficiaries: null,
  beneficiariesToSelect: null,
  beneficiariesChecked: null,
  beneficiariesToMessage: null,
  beneficiaryWithCollectionCount: 0,
  total: 0,
  totalBeneficiaries: 0,
  beneficiariesByCompanyOrProgramme: 0,
  beneficiariesToAccessControll: null,
}

const beneficiaryReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_BENEFICIARIES_TO_ACCESS_CONTROL: {
      const { beneficiaries } = action
      return {
        ...state,
        beneficiariesToAccessControll: beneficiaries,
      }
    }
    case SET_REPORT_DATA: {
      const { reportData } = action
      return {
        ...state,
        reportData,
      }
    }
    case SET_BENEFICIARIES: {
      const { beneficiaries } = action
      return {
        ...state,
        beneficiaries: beneficiaries.list,
        total: beneficiaries.total,
        totalBeneficiaries: beneficiaries.totalBeneficiaries,
      }
    }
    case SET_BENEFICIARIES_TO_SELECT: {
      const { beneficiaries } = action
      return {
        ...state,
        beneficiariesToSelect: beneficiaries.list,
      }
    }
    case SET_BENEFICIARIES_TO_MESSAGE: {
      const { beneficiaries } = action
      return {
        ...state,
        beneficiariesToMessage: beneficiaries.list,
      }
    }
    case SET_BENEFICIARIES_CHECKED: {
      const { beneficiaries } = action
      return {
        ...state,
        beneficiariesChecked: beneficiaries,
      }
    }
    case SET_COUNT_BENEFICIARIES_WITH_COLLECTION: {
      const { beneficiaryWithCollectionCount } = action
      return {
        ...state,
        beneficiaryWithCollectionCount,
      }
    }

    case CLEAR_BENEFICIARY: {
      return defaultState
    }

    case SET_COUNT_BENEFICIARIES_BY_COMPANY_OR_PROGRAMME: {
      const { beneficiariesByCompanyOrProgramme } = action
      return {
        ...state,
        beneficiariesByCompanyOrProgramme,
      }
    }
    case UPDATE_BENEFICIARY_PHOTO_IN_STORE: {
      const { beneficiaryId, base64 } = action
      // eslint-disable-next-line max-len
      const list = (state.beneficiaries || []).map((b) => (b.id === beneficiaryId ? { ...b, profileImageBase64: base64 } : b))
      return { ...state, beneficiaries: list }
    }

    default:
      return state
  }
}

export default beneficiaryReducer
